export default [
  {
    path: '/admin/trader/coins',
    name: 'Coins',
    component: () => import('@/views/Admin/Trader/Coins/Index.vue'),
    meta: {
      pageTitle: 'Coin Listesi',
      breadcrumb: [
        {
          text: 'Trader',
          active: false,
        },
        {
          text: 'Coinler',
          active: true,
        },
      ],
      resource: 'coins.list',
      action: 'read',
    },
  },
]
